/**
 * `dias` de un turno llega como array desde el calendario (que hace JSON.parse) pero como
 * string JSON desde el buscador (helpers.js pasa el turno crudo de /turnos/search).
 * Normalizar en un solo punto evita que cada consumidor tenga que adivinar cuál recibió:
 * un `dias[0]` sobre el string devuelve '[', y de ahí salían fechas `undefined`.
 *
 * Devuelve siempre un array; [] si no se puede interpretar.
 */
export function normalizaDias(dias) {
  if (Array.isArray(dias)) return dias;
  if (typeof dias === 'string') {
    try {
      const v = JSON.parse(dias);
      return Array.isArray(v) ? v : [];
    } catch {
      return [];
    }
  }
  return [];
}
